<template>
  <div id="app">
    <!--导航-->
    <part-nav></part-nav>

    <div class="toast">注册成功</div>

    <!--页面主体-->
    <div :class="{ mt50: isMobile }">
      <router-view />
    </div>

    <!--footer-->
    <part-footer></part-footer>
  </div>
</template>

<style lang="scss">
.toast {
  display: none;
  width: 80px;
  padding: 10px;
  line-height: 1.5;
  background: #4d4d4d;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  position: fixed;
  top: 50%;
  margin-top: -20px;
  z-index: 999;
  left: 50%;
  margin-left: -50px;
}
</style>

<script>
import DY from '../src/assets/js/common';
import partNav from '../src/components/partNav.vue';
import partFooter from '../src/components/partFooter.vue';

export default {
  name: 'index',
  data() {
    return {
      isMobile: DY.isMobile,
    };
  },

  components: {
    partNav,
    partFooter,
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue